import { createRoot } from 'react-dom/client'
import '@fontsource-variable/geist'
import '@fontsource-variable/geist-mono'
import App from './App.tsx'
import './index.css'

createRoot(document.getElementById("root")!).render(<App />);
